import ActionTypes from '../constants';

const initialState = {
    products: {},
    product: {},
    productAttributes: {},
    productAttributesValue: {},
    // loading: false,
};

const productReducer = (state = initialState, action) => {
    switch (action.type) {
        // case ActionTypes.LOADING:
        //     return {
        //         ...state,
        //         loading: true
        //     }
        case ActionTypes.GETPRODUCTSUCCESS:
            return {
                ...state,
                products: action.payload,
            }
        case ActionTypes.GETPRODUCTBYIDSUCCESS:
            return {
                ...state,
                product: action.payload,
            }
        case ActionTypes.GETPRODUCTBYCATEGORYIDSUCCESS:
            return {
                ...state,
                products: action.payload,
            }
        case ActionTypes.GETPRODUCTATTRIBUTESUCCESS:
            return {
                ...state,
                productAttributes: action.payload,
            }
        case ActionTypes.GETPRODUCTATTRIBUTEVALUESUCCESS:
            return {
                ...state,
                productAttributesValue: action.payload,
            }
        default:
            return state;
    }
}

export default productReducer;